import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  GetPerimeterExport,
  UseGetPerimeterExportParams,
} from "./apiEcms.types";

const getPerimeterExport = async (signal: AbortSignal) => {
  const { data } = await apiEcmsHttp.get<GetPerimeterExport>(
    "/perimeter-export",
    { signal },
  );

  return data;
};

export const useGetPerimeterExport = <TSelect = GetPerimeterExport>({
  isAdmin,
  options,
}: UseGetPerimeterExportParams<TSelect>) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.PERIMETER_EXPORT, currentGroup],
    queryFn: ({ signal }) => getPerimeterExport(signal),
    retry: false,
    staleTime: 15000,
    enabled: isAdmin,
    ...options,
  });
};
